export type Theme = 'dark' | 'light';

export type ThemeOption = Theme | 'system';

export const themeLabels: Record<ThemeOption, string> = {
  light: 'Light',
  dark: 'Dark',
  system: 'System',
};
